import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

//Images
import Faq from './question.svg'

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Calendar.css';
import {
    Row,
    Col,
    FormGroup,
    Tooltip,
    OverlayTrigger,
} from 'react-bootstrap';
import cx from 'classnames';

// Component
import CurrencyConverter from '../../CurrencyConverter';

// Helper
import bookingCalculations from '../../../helpers/bookingCalculations';

// Locale
import messages from '../../../locale/messages';

class BillDetails extends Component {
    static propTypes = {
        basePrice: PropTypes.number.isRequired,
        cleaningPrice: PropTypes.number,
        currency: PropTypes.string.isRequired,
        monthlyDiscount: PropTypes.number,
        weeklyDiscount: PropTypes.number,
        startDate: PropTypes.object.isRequired,
        endDate: PropTypes.object.isRequired,
        serviceFees: PropTypes.shape({
            guest: PropTypes.shape({
                type: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired,
                currency: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        base: PropTypes.string.isRequired,
        rates: PropTypes.object.isRequired,
        formatMessage: PropTypes.any,
        specialPricing: PropTypes.array,
        isHotDesking: PropTypes.bool,
        isOpenOnWeekends: PropTypes.bool,
        freeTrialDays: PropTypes.number,
        guests: PropTypes.number,
    };

    static defaultProps = {
        basePrice: 0,
        cleaningPrice: 0,
        monthlyDiscount: 0,
        weeklyDiscount: 0,
        startDate: null,
        endDate: null,
        specialPricing: [],
        isHotDesking: false,
        isOpenOnWeekends: false,
        freeTrialDays: 0,
        guests: 1,
    }

    render() {
        const { basePrice, promoPrice, promoDays, cleaningPrice, currency, monthlyDiscount, weeklyDiscount, startDate, endDate } = this.props;
        const { serviceFees, base, rates, specialPricing, taxRate } = this.props;
        const { isHotDesking, isOpenOnWeekends, freeTrialDays, guests, useFreeTrial, projectTicketmaster } = this.props;
        const { formatMessage } = this.props.intl;

        const { freeTrialDaysCount, stayLengthBillable, isSpecialPriceAssigned, averageDayRate, priceForDays, discount, discountType, guestServiceFee, subTotal, taxAmount, total } = bookingCalculations.standardBooking({
          basePrice,
          promoPrice,
          cleaningPrice,
          currency,
          monthlyDiscount,
          weeklyDiscount,
          startDate,
          endDate,
          serviceFees,
          base,
          rates,
          specialPricing,
          taxRate,
          isHotDesking,
          isOpenOnWeekends,
          freeTrialDays,
          guests,
          useFreeTrial,
          projectTicketmaster,
          formatMessage
        });

        let t = 1;

        /* function LinkWithTooltip({ id, children, href, tooltip }) {
            return (
                <OverlayTrigger
                    overlay={<Tooltip className={s.tooltip} id={id}>{tooltip}</Tooltip>}
                    placement="top"
                    delayShow={300}
                    delayHide={150}
                >
                    {children}
                </OverlayTrigger>
            );
        } */

        return (
            <FormGroup>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <table className={cx('table')}>
                            <tbody>
                                <tr className={cx(s.positionR)}>
                                    <td className={cx(s.noBorder)}>
                                        {
                                            freeTrialDaysCount > 0 && <div className={cx(s.specialPriceText, 'directionLtr')}>
                                                <CurrencyConverter
                                                    amount={0}
                                                    from={currency}
                                                />
                                                { isHotDesking == true && <span>
                                                    {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                                                </span> }
                                                {' x'} {freeTrialDaysCount} {freeTrialDaysCount > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)} {formatMessage(messages.freeTrial)}
                                            </div>
                                        }
                                        {
                                            stayLengthBillable > 0 && isSpecialPriceAssigned && <div className={cx(s.specialPriceIcon, 'specialpriceRtl')}>
                                                <span>
                                                    <img src={Faq} className={cx(s.faqImage, 'specialpriceRtl')} />
                                                </span>
                                                <div className={cx(s.tltip, s.relativeSection)}>
                                                    <FormattedMessage {...messages.averagePricePerNight} />
                                                </div>
                                            </div>
                                        }
                                        {
                                          (promoPrice) && (promoDays) && <div className={cx(s.specialPriceText, 'directionLtr')} style={{color: '#E8505B'}}>
                                              <CurrencyConverter
                                                  amount={promoPrice}
                                                  from={currency}
                                              />
                                              { isHotDesking == true && <span>
                                                  {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                                              </span> }
                                              {' x'} {promoDays} {promoDays > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                          </div>
                                        }
                                        {
                                            (stayLengthBillable-promoDays) > 0 && isSpecialPriceAssigned &&
                                            <div className={cx(s.specialPriceText, s.paddingLeft, 'paddingLeftRtl', 'directionLtr')}>
                                                <CurrencyConverter
                                                    amount={averageDayRate}
                                                    from={currency}
                                                />
                                                { isHotDesking == true && <span>
                                                    {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                                                </span> }
                                                {' x'} {stayLengthBillable-promoDays} {(stayLengthBillable-promoDays) > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                            </div>
                                        }
                                        {
                                            (stayLengthBillable-promoDays) > 0 && !isSpecialPriceAssigned && <div className={cx(s.specialPriceText, 'directionLtr')}>
                                                <CurrencyConverter
                                                    amount={averageDayRate}
                                                    from={currency}
                                                />
                                                { isHotDesking == true && <span>
                                                    {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                                                </span> }
                                                {' x'} {stayLengthBillable-promoDays} {(stayLengthBillable-promoDays) > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                            </div>
                                        }
                                    </td>
                                    <td className={cx(s.noBorder, 'text-right')}>
                                        <CurrencyConverter
                                            amount={priceForDays}
                                            from={currency}
                                        />
                                    </td>
                                </tr>
                                {
                                    discount > 0 && <tr>
                                        <td>{discountType}</td>
                                        <td className={cx('text-right', s.discountText)}>
                                            <span className={cx(s.displayCell, s.decresePadding, s.decWidth)}>-</span>
                                            <span className={s.displayCell}>
                                                <CurrencyConverter
                                                    amount={discount}
                                                    from={currency}
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {
                                    cleaningPrice > 0 && <tr>
                                        <td><FormattedMessage {...messages.cleaningFee} /></td>
                                        <td className={cx('text-right')}>
                                            <CurrencyConverter
                                                amount={cleaningPrice}
                                                from={currency}
                                            />
                                        </td>
                                    </tr>
                                }
                                {
                                    guestServiceFee > 0 && <tr>
                                        <td><FormattedMessage {...messages.serviceFee} /></td>
                                        <td className={cx('text-right')}>
                                            <CurrencyConverter
                                                amount={guestServiceFee}
                                                from={currency}
                                            />
                                        </td>
                                    </tr>
                                }
                                {
                                    taxAmount > 0 && <React.Fragment>
                                {/* <tr>
                                  <td><FormattedMessage {...messages.subTotal} /></td>
                                  <td className={cx('text-right')}>
                                      <CurrencyConverter
                                          amount={subTotal}
                                          from={currency}
                                      />
                                  </td>
                                </tr> */}
                                <tr>
                                  <td><FormattedMessage {...messages.VAT} /> @{taxRate}%</td>     
                                  <td className={cx('text-right')}>
                                      <CurrencyConverter
                                          amount={taxAmount}
                                          from={currency}
                                      />
                                  </td>
                                </tr>
                                </React.Fragment>
                                }
                                <tr>
                                    <td><FormattedMessage {...messages.total} /></td>
                                    <td className={cx('text-right')}>
                                        <CurrencyConverter
                                            amount={total}
                                            from={currency}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </FormGroup>
        );
    }
}

const mapState = (state) => ({
    specialPricing: state.viewListing.specialPricing
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BillDetails)));


// WEBPACK FOOTER //
// src/components/ViewListing/Calendar/BillDetails.js